import { render } from "./BillsToReceive.vue?vue&type=template&id=1ef067c8"
import script from "./BillsToReceive.vue?vue&type=script&lang=js"
export * from "./BillsToReceive.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__